import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import cytoscape from 'cytoscape';
import cise from 'cytoscape-cise';
import coseBilkent from 'cytoscape-cose-bilkent';
import cola from 'cytoscape-cola';
import euler from 'cytoscape-euler';
import { FormBuilder, FormGroup } from '@angular/forms';

cytoscape.use(euler);
cytoscape.use(cola);
cytoscape.use(cise);
cytoscape.use(coseBilkent);

@Component({
  selector: 'app-layout-menu',
  templateUrl: './layout-menu.component.html',
  styleUrls: ['./layout-menu.component.css', '../mediaquerie.css']
})
export class LayoutMenuComponent implements OnInit {
  @Input() cy: any;
  @Input() focusNode: string;
  // emetto scelta layout per mantenerlo nel form 
  @Output() emettoLayoutCise = new EventEmitter<boolean>();
  @Output() emettoLayoutCoseBilkent = new EventEmitter<boolean>();
  @Output() emettoLayoutCola = new EventEmitter<boolean>();
  @Output() emettoLayoutEuler = new EventEmitter<boolean>();
  @Output() emettoLayoutCose = new EventEmitter<boolean>();

  // emetto valore checkbox 
  @Output() checkboxIpo = new EventEmitter<boolean>();
  @Output() checkboxMero = new EventEmitter<boolean>();
  @Output() checkboxSino = new EventEmitter<boolean>();

  // emetto valore is checked 
  @Output() labelChecked = new EventEmitter<boolean>();

  // evento per disabilitare form distanza relazione iponimia
  @Output() disabilitoIpo = new EventEmitter<boolean>();
  @Output() disabilitoIpe = new EventEmitter<boolean>();

  // evento per disabilitare form distanza relazione meronimia
  @Output() disabilitoMero = new EventEmitter<boolean>();
  @Output() disabilitoOlo = new EventEmitter<boolean>();

  layoutCiseScelto: boolean;
  layoutCoseBilkentScelto: boolean;
  layoutColaScelto: boolean;
  layoutEulerScelto: boolean;
  layoutCoseScelto: boolean;
  isCheck = false;
  relazioniVisualizzate: FormGroup;
  disabilitaBtnMenu: boolean = false;
  constructor(fb: FormBuilder) {
    this.relazioniVisualizzate = fb.group({
      iponimia: true,
      meronimia: true,
      sinonimia: true,
    });
  }

  ngOnInit(): void {
  }

  ciseLayout() {
    this.emettoLayoutCise.emit(true);
    this.emettoLayoutCoseBilkent.emit(false);
    this.emettoLayoutCola.emit(false);
    this. emettoLayoutEuler.emit(false);
    this.emettoLayoutCose.emit(false);
    // disab form distanza ipo e mero
    this.disabilitoIpo.emit(true);
    this.disabilitoIpe.emit(true);
    this.disabilitoMero.emit(true);
    this.disabilitoOlo.emit(true);

    this.layoutCiseScelto = true;
    var layout = this.cy.elements().filter(':visible').layout({
      name: 'cise',
      nodeSeparation: 0.1,
      allowNodesInsideCircle: false,
      maxRatioOfNodesInsideCircle: 0.1,
      animate: false,
      refresh: 0.5,
      idealInterClusterEdgeLengthCoefficient: 2,
      fit: false,
    });
    layout.run();
    var elementiVisibili = this.cy.elements(':visible');
    this.cy.center(elementiVisibili);
  }

  coseBilkentLayout() {
    this.layoutCoseBilkentScelto = true;
    this.emettoLayoutCoseBilkent.emit(true);
    this.emettoLayoutCise.emit(false);
    this.emettoLayoutCola.emit(false);
    this. emettoLayoutEuler.emit(false);
    this.emettoLayoutCose.emit(false);
    // disab form distanza ipo e mero
    this.disabilitoIpo.emit(true);
    this.disabilitoIpe.emit(true);
    this.disabilitoMero.emit(true);
    this.disabilitoOlo.emit(true);
    var layout = this.cy.elements().filter(':visible').layout({
      name: 'cose-bilkent',
      quality: 'default',
      animate: 'end',
      animationEasing: 'ease-out',
      animationDuration: 1000,
      randomize: true,
      fit: false,
      idealEdgeLength: 100,
    });
    layout.run();
    var elementiVisibili = this.cy.elements(':visible');
    this.cy.center(elementiVisibili);
  }

  colaLayout() {
    this.layoutColaScelto = true;
    this.emettoLayoutCola.emit(true);
    this.emettoLayoutCoseBilkent.emit(false);
    this.emettoLayoutCise.emit(false);
    this. emettoLayoutEuler.emit(false);
    this.emettoLayoutCose.emit(false);
    // disab form distanza ipo e mero
    this.disabilitoIpo.emit(true);
    this.disabilitoIpe.emit(true);
    this.disabilitoMero.emit(true);
    this.disabilitoOlo.emit(true);
    var layout = this.cy.elements().filter(':visible').layout({
      name: 'cola',
      animate: true,
      refresh: 1,
      maxSimulationTime: 4000,
      ungrabifyWhileSimulating: false,
      fit: false,
      padding: 30,
      nodeDimensionsIncludeLabels: false,
      randomize: false,
      avoidOverlap: true,
      handleDisconnected: true,
      convergenceThreshold: 0.01,
      nodeSpacing: function (node) { return 10; },
      flow: undefined,
      alignment: undefined,
      gapInequalities: undefined,
      centerGraph: true,
      edgeLength: undefined,
      edgeSymDiffLength: undefined,
      edgeJaccardLength: undefined,
      unconstrIter: undefined,
      userConstIter: undefined,
      allConstIter: undefined,
    });
    layout.run();
    var elementiVisibili = this.cy.elements(':visible');
    this.cy.center(elementiVisibili);
  }

  eulerLayout() {
    this.layoutEulerScelto = true;
    this.emettoLayoutEuler.emit(true);
    this.emettoLayoutCoseBilkent.emit(false);
    this.emettoLayoutCise.emit(false);
    this.emettoLayoutCola.emit(false);
    this.emettoLayoutCose.emit(false);
    // disab form distanza ipo e mero
    this.disabilitoIpo.emit(true);
    this.disabilitoIpe.emit(true);
    this.disabilitoMero.emit(true);
    this.disabilitoOlo.emit(true);
    var layout = this.cy.elements().filter(':visible').layout({
      name: 'euler',
      randomize: true,
      springLength: edge => 200,
      animate: false,
      fit: false,
    });
    layout.run();
    var elementiVisibili = this.cy.elements(':visible');
    this.cy.center(elementiVisibili);
  }

  coseLayout() {
    this.layoutCoseScelto = true;
    this.emettoLayoutCose.emit(true);
    this.emettoLayoutCoseBilkent.emit(false);
    this.emettoLayoutCise.emit(false);
    this.emettoLayoutCola.emit(false);
    this. emettoLayoutEuler.emit(false);
    // disab form distanza ipo e mero
    this.disabilitoIpo.emit(true);
    this.disabilitoIpe.emit(true);
    this.disabilitoMero.emit(true);
    this.disabilitoOlo.emit(true);
    var layout = this.cy.elements().filter(':visible').layout({
      name: 'cose',
      animate: true,
      animationEasing: undefined,
      animationDuration: undefined,
      animateFilter: function (node, i) { return true; },
      animationThreshold: 250,
      refresh: 20,
      fit: false,
      padding: 30,
      boundingBox: undefined,
      nodeDimensionsIncludeLabels: false,
      randomize: false,
      componentSpacing: 40,
      nodeRepulsion: function (node) { return 2048; },
      nodeOverlap: 4,
      idealEdgeLength: function (edge) { return 32; },
      edgeElasticity: function (edge) { return 32; },
      nestingFactor: 1.2,
      gravity: 1,
      numIter: 1000,
      initialTemp: 1000,
      coolingFactor: 0.99,
      minTemp: 1.0
    });
    layout.run();
    var elementiVisibili = this.cy.elements(':visible');
    this.cy.center(elementiVisibili);
  }

  isChecked() {
    if (this.isCheck === true) {
      this.labelChecked.emit(true);
      this.cy.edges().filter(':visible').addClass('label');
      this.cy.edges().filter(':visible').style("edge-text-rotation", "autorotate");
      this.disabilitoIpo.emit(true);
      this.disabilitoIpe.emit(true);
      this.disabilitoMero.emit(true);
      this.disabilitoOlo.emit(true);
    }
    else {
      this.labelChecked.emit(false);
      this.cy.edges().filter(':visible').removeClass('label');
      this.disabilitoIpo.emit(true);
      this.disabilitoIpe.emit(true);
      this.disabilitoMero.emit(true);
      this.disabilitoOlo.emit(true);
    }
  }

  iponimiaSelezionata() {
    var focusNode = this.cy.getElementById(sessionStorage.getItem('focusNode'))
    var valoreIpoCheckbox = this.relazioniVisualizzate.get('iponimia').value;
    var iponimiVisibili = this.cy.edges("[relationType='hyponym']");
    if (valoreIpoCheckbox === false) {
      this.checkboxIpo.emit(false);
      for (var i = 0; i < iponimiVisibili.length; i++) {
        if (iponimiVisibili[i].source() !== focusNode) {
          // rimuovo nodi
          iponimiVisibili[i].source().style('display', 'none');
        }
        if (iponimiVisibili[i].target() !== focusNode) {
          // rimuovo nodi
          iponimiVisibili[i].target().style('display', 'none');
        }
      }
    } else {
      this.checkboxIpo.emit(true);
      for (var i = 0; i < iponimiVisibili.length; i++) {
        iponimiVisibili[i].source().style('display', 'element')
        iponimiVisibili[i].target().style('display', 'element')
        iponimiVisibili[i].style('display', 'element')
      }
    }
  }

  meronimiaSelezionata() {
    var focusNode = this.cy.getElementById(sessionStorage.getItem('focusNode'));
    var valoreMeroCheckbox = this.relazioniVisualizzate.get('meronimia').value;
    var meronimiVisibili = this.cy.edges('[relationType= "partMeronym"]')
    if (valoreMeroCheckbox === false) {
      this.checkboxMero.emit(false);
      for (var i = 0; i < meronimiVisibili.length; i++) {
        if (meronimiVisibili[i].source() !== focusNode) {
          // rimuovo nodi
          meronimiVisibili[i].source().style('display', 'none');
        }
        if (meronimiVisibili[i].target() !== focusNode) {
          // rimuovo nodi
          meronimiVisibili[i].target().style('display', 'none');
        }
      }
    } else {
      this.checkboxMero.emit(true);
      for (var i = 0; i < meronimiVisibili.length; i++) {
        meronimiVisibili[i].source().style('display', 'element')
        meronimiVisibili[i].target().style('display', 'element')
        meronimiVisibili[i].style('display', 'element')
      }
    }
  }

  sinonimiaSelezionata() {
    var focusNode = this.cy.getElementById(sessionStorage.getItem('focusNode'));
    var valoreSinoCheckbox = this.relazioniVisualizzate.get('sinonimia').value;
    var sinonimiVisibili = this.cy.edges('[relationType= "synonym"]');
    if (valoreSinoCheckbox === false) {
      this.checkboxSino.emit(false);
      for (var i = 0; i < sinonimiVisibili.length; i++) {
        if (sinonimiVisibili[i].source() !== focusNode) {
          // rimuovo nodi
          sinonimiVisibili[i].source().style('display', 'none');
        }
        if (sinonimiVisibili[i].target() !== focusNode) {
          // rimuovo nodi
          sinonimiVisibili[i].target().style('display', 'none');
        }
      }
      // focusNode.restore();
    } else {
      this.checkboxSino.emit(true);
      for (var i = 0; i < sinonimiVisibili.length; i++) {
        sinonimiVisibili[i].source().style('display', 'element')
        sinonimiVisibili[i].target().style('display', 'element')
        sinonimiVisibili[i].style('display', 'element')
      }
    }
  }
}
